import { Action, ActionReducer, createReducer, on } from '@ngrx/store';
import * as actions from './user-assets.actions';
import { UserAssetsState, initialState } from './user-assets.state';

const reducer: ActionReducer<UserAssetsState, Action> = createReducer(
  initialState,
  on(
    actions.downloadMyAsset,
    (state, { userAssetId }): UserAssetsState => ({
      ...state,
      downloadingFile: userAssetId,
    })
  ),
  on(
    actions.downloadMyAssetSuccess,
    (state): UserAssetsState => ({
      ...state,
      downloadingFile: null,
    })
  ),
  on(
    actions.downloadMyAssetError,
    (state): UserAssetsState => ({
      ...state,
      downloadingFile: null,
    })
  ),
  on(
    actions.removeMyAsset,
    (state): UserAssetsState => ({
      ...state,
      loading: true,
    })
  ),
  on(
    actions.uploadPreSurveyAttachments,
    (state): UserAssetsState => ({
      ...state,
      loading: true,
    })
  ),
  on(
    actions.uploadPreSurveyAttachmentsSuccess,
    actions.uploadPreSurveyAttachmentsError,
    actions.removeMyAssetSuccess,
    actions.removeMyAssetError,
    (state): UserAssetsState => ({
      ...state,
      loading: false,
    })
  )
);

export function userAssetsReducer(state: UserAssetsState, action: Action): UserAssetsState {
  return reducer(state, action);
}
